import React from 'react';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultProcessArtifactResource,
    ProcessArtifactMutationResourceSchema,
    useProcessArtifactActions,
} from '../../../../../resource/resources/artifacts/process_artifact/processArtifactResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import {
    Form_DisplayComponentBaseView,
} from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { ProcessArtifactContent } from './ProcessArtifactContent';

export const ProcessArtifactEditDialog= ({ onClose, objectId, versionedInId }: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const processArtifactActions = useProcessArtifactActions()
    const processArtifactQuery = processArtifactActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateProcessArtifact = processArtifactActions.useUpdateResource();
    const validation = processArtifactActions.useValidateResource(processArtifactQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessArtifactMutationResourceSchema,
        defaultValues: defaultProcessArtifactResource,
        submitHandler: async (data) => {
            await updateProcessArtifact.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: processArtifactQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Process Artifact'}
            resourceType={ResourceType.PROCESS_ARTIFACT}
            resourceValidationResult={validation.data}
            metaDataInfo={processArtifactQuery.data}
        >
            <QueryBaseComponent name="ProcessArtifact" query={processArtifactQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <ProcessArtifactContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={processArtifactQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
